import client from './client';
// @todo - must be removed
export const syncCalendar = data => client().post('/google', data);
// @todo - must be removed
export const getOAuthUrl = () => client().get('/google');

export const googleApiPost = data => client().post('/google', data);
export const googleApiGet = (data = {}) => client().get('/google', { params: data });
export const googleApiDelete = ({ id, data = {} }) => client().delete(`/google/${id}`, { params: data });
